'use client'

import { Button } from '@vinted/web-ui'

import { MAX_FACETED_ITEMS_COUNT } from '@marketplace-web/catalog/catalog-data'
import { useCatalogContext } from '@marketplace-web/catalog/catalog-page-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

type Props = {
  totalItemsCount?: number | null
  maxItemsCount?: number | null
  isAsync?: boolean
  onSubmit?: () => void
}

const FilterSelectionButton = ({ totalItemsCount, maxItemsCount, isAsync, onSubmit }: Props) => {
  const translate = useTranslate('catalog.filters.mobile')
  const {
    state: {
      dynamicFilters: { filterFacetsCountMax },
    },
  } = useCatalogContext()

  const baseText = translate('filters_screen.actions.show_results')
  const totalFactedItemsCount =
    (isAsync ? filterFacetsCountMax : maxItemsCount) || MAX_FACETED_ITEMS_COUNT
  let submitButtonText = baseText

  if (totalItemsCount === null || totalItemsCount === undefined) {
    submitButtonText = baseText
  } else if (totalItemsCount >= totalFactedItemsCount) {
    submitButtonText = `${baseText} (${totalFactedItemsCount}+)`
  } else {
    submitButtonText = `${baseText} (${totalItemsCount})`
  }

  return (
    <div className="u-ui-padding-medium">
      <Button
        onClick={onSubmit}
        theme="primary"
        text={submitButtonText}
        styling={Button.Styling.Filled}
        testId="filter-selection-button"
      />
    </div>
  )
}

export default FilterSelectionButton
